<template>
    <b-container fluid class="no-padding bottom-padding">
        <canvas ref='drawdownCanvas' :renderingKey='renderingKey' :width='canvasWidth' :height='canvasHeight'/>
    </b-container>
</template>

<script>
import draftEditorService from '../mixins/draftEditorService.js'
import utilityService from '../mixins/utilityService.js'

export default {
    props: {
        shaftsCount: {
            type: Number,
            required: true
        },
        treadlesCount: {
            type: Number,
            required: true
        },
        warpThreadsCount: {
            type: Number,
            required: true
        },
        weftThreadsCount: {
            type: Number,
            required: true
        },
        warpThreads: {
            type: Array,
            required: true
        },
        weftThreads: {
            type: Array,
            required: true
        },
        treadling: {
            type: Array,
            required: true
        },
        threading: {
            type: Array,
            required: true
        },
        tieup: {
            type: Array,
            required: true
        },
        cellPixelSize: {
            type: Number,
            required: true
        },
        borderThicknessPixels: {
            type: Number,
            required: true
        },
        showDividingLines: {
            type: Boolean,
            required: true
        },
        renderingKey: {
            type: String,
            required: true
        },
        showReverseSide: {
            type: Boolean,
            required: true
        },
        overshotTabbyTreadleNumbers: {
            type: Array,
            required: true
        }
    },
    mixins: [draftEditorService, utilityService],
    components: {
    },
    data() {
        return {
            patternDrawdownArray: [],
            groundDrawdownArray: [],
            patternWeftThreadsArray: [],
            groundWeftThreadsArray: [],
            vueCanvas: null,
            rowsCount: 0,
            columnsCount: 0
        }
    },
    methods: {

        buildDrawdownArrays() {
            // console.log('groundDrawdownArray: ' + JSON.stringify(this.groundDrawdownArray))
            // console.log('patternDrawdownArray: ' + JSON.stringify(this.patternDrawdownArray))
            // console.log('building')
            this.groundDrawdownArray = this.initializeDrawdownArray(this.warpThreadsCount, Math.ceil(this.weftThreadsCount/2))
            this.patternDrawdownArray = this.initializeDrawdownArray(this.warpThreadsCount, Math.ceil(this.weftThreadsCount/2))

            let groundWeaveTreadling = []
            let patternWeaveTreadling = []

            this.patternWeftThreadsArray = []
            this.groundWeftThreadsArray = []

            let groundWeaveFirstTreadle = this.overshotTabbyTreadleNumbers[0]
            let groundWeaveSecondTreadle = this.overshotTabbyTreadleNumbers[1]

            for (let t = 0; t < this.weftThreadsCount; t++) {
                let pick = this.treadling[t]
                let thread = this.weftThreads[t]
                // console.log('thread' + t + ': ' + JSON.stringify(thread))
                if (pick[groundWeaveFirstTreadle] || pick[groundWeaveSecondTreadle]) {
                    groundWeaveTreadling.push(pick)
                    this.groundWeftThreadsArray.push(thread)
                }
                else {
                    patternWeaveTreadling.push(pick)
                    this.patternWeftThreadsArray.push(thread)
                }
            }

            let affectedWarpThreadNumbers = []
            for (let c=0; c<this.warpThreadsCount; c++) {
                affectedWarpThreadNumbers.push(c)
            }

            let affectedGroundWeftThreadNumbers = []
            for (let c=0; c<groundWeaveTreadling.length; c++) {
                affectedGroundWeftThreadNumbers.push(c)
            }

            let affectedPatternWeftThreadNumbers = []
            for (let c=0; c<patternWeaveTreadling.length; c++) {
                affectedPatternWeftThreadNumbers.push(c)
            }
            /*
            console.log('originalTreadling: ' + JSON.stringify(this.treadling))
            console.log('groundWeaveTreadling: ' + JSON.stringify(groundWeaveTreadling))
            console.log('patternWeaveTreadling: ' + JSON.stringify(patternWeaveTreadling))
            console.log('originalWeftThreads: ' + JSON.stringify(this.weftThreads))
            console.log('groundWeaveWeftThreadsArray: ' + JSON.stringify(this.groundWeftThreadsArray))
            console.log('patternWeftThreadsArray: ' + JSON.stringify(this.patternWeftThreadsArray))
            console.log('affectedWarpThreadNumbers: ' + JSON.stringify(affectedWarpThreadNumbers))
            console.log('affectedGroundWeftThreadNumbers: ' + JSON.stringify(affectedGroundWeftThreadNumbers))
            console.log('affectedPatternWeftThreadNumbers: ' + JSON.stringify(affectedPatternWeftThreadNumbers))
            */
            this.loadDrawdown(this.shaftsCount, this.treadlesCount, this.warpThreadsCount, groundWeaveTreadling.length, affectedWarpThreadNumbers, affectedGroundWeftThreadNumbers, this.groundDrawdownArray, groundWeaveTreadling, this.threading, this.tieup)
            this.loadDrawdown(this.shaftsCount, this.treadlesCount, this.warpThreadsCount, patternWeaveTreadling.length, affectedWarpThreadNumbers, affectedPatternWeftThreadNumbers, this.patternDrawdownArray, patternWeaveTreadling, this.threading, this.tieup)
            // }
            // else {
            //     console.log('not building')
            // }
        },

        drawGroundAndPatternWeaves() {
            // console.log('drawGroundAndPatternWeaves')
            this.renderDrawdown(this.vueCanvas, this.groundDrawdownArray, this.groundWeftThreadsArray, true, true, this.showReverseSide)
            this.renderDrawdown(this.vueCanvas, this.patternDrawdownArray, this.patternWeftThreadsArray, false, false, this.showReverseSide)
        },

        initializeComponent() {
            this.rowsCount = this.weftThreadsCount / 2
            this.columnsCount = this.warpThreadsCount
            this.buildDrawdownArrays()
            this.drawGroundAndPatternWeaves()
        }
    },

    watch: {
    },
    computed: {
        canvasWidth: function() {
            return (this.columnsCount * this.cellPixelSize) + ((this.columnsCount+1) * (this.borderThicknessPixels))
        },
        canvasHeight: function() {
            return (this.rowsCount * this.cellPixelSize) + ((this.rowsCount+1) * (this.borderThicknessPixels))
        }
    },
    created() {
        // console.log('in GroundWeaveDrawdown created')
    },
    mounted() {
        // console.log('in GroundWeaveDrawdown mounted')
        let c = this.$refs['drawdownCanvas']
        let ctx = c.getContext('2d')
        this.vueCanvas = ctx
        this.initializeComponent()
    },
    updated() {
        // console.log('in GroundWeaveDrawdown updated')
        this.initializeComponent()
    }
}
</script>

<style scoped>
input[type=file] {
    cursor: pointer; 
}
</style>



// WEBPACK FOOTER //
// src/components/GroundWeaveDrawdown.vue